/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomComponentDetails {
    getFixupPrototypeFunction() { return AppSecopsSbomComponentDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomComponentDetails>): AppSecopsSbomComponentDetails {
        let obj = Object.assign(new AppSecopsSbomComponentDetails(), model);
        AppSecopsSbomComponentDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomComponentDetails>): AppSecopsSbomComponentDetails {
        if (!model) return null;
        return AppSecopsSbomComponentDetails.newInstance(<AppSecopsSbomComponentDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomComponentDetails) {
        if (!obj) return;

        models.AppSecopsSbomComponentDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomComponentDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomComponentDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the component
     */
    name: string;

    /**
     * Unique identifier for the component
     */
    component_id: string;

    /**
     * List of BOM references that this component depends on
     */
    dependent_component_ids: Array<string>;

}
